import { type FC, type ReactNode } from 'react';

import styles from './MapControlsSlots.css';

type MapMapControlsSlotsProps = {
  rightControls?: ReactNode;
  topControls?: ReactNode;
};

export const MapControlsSlots: FC<MapMapControlsSlotsProps> = ({ rightControls, topControls }) => {
  return (
    <div className={styles['map-controls-container']}>
      <div className={styles['map-controls-wrapper']}>
        {topControls && <div className={styles['top-controls']}>{topControls}</div>}
        {rightControls && <div className={styles['right-controls']}>{rightControls}</div>}
      </div>
    </div>
  );
};
